import Vue from 'vue';
import JudgingFastStart from './JudgingFastStart';
import store from '../../lib/store';

export default function () {
  const judgingFastStartEl = document.getElementById('judging-fast-start');

  if (judgingFastStartEl) {
    const judgingFastStart = new Vue({
      el: judgingFastStartEl,
      components: {
        JudgingFastStart
      },
      store
    });

    $(document).one('pjax:end', () => {
      judgingFastStart.$destroy();
    });
  }
};
